export const defaultSeatingDomainState = {
    areaCategories: {},
    seatLayouts: {},
    seatAvailabilities: {},
    seatAvailabilityPreviews: {}
};
//# sourceMappingURL=state.js.map